/**
 * Anzeige, wenn die Anwendung gar nicht erst startet.
 *
 * Bewusst ohne Theme und ohne eigene Komponenten: Wer hier landet, hat unter
 * Umständen ein Problem beim Laden überhaupt — dann soll die Fehlermeldung
 * nicht selbst noch von etwas abhängen. Deshalb auch keine Tailwind-Klassen,
 * sondern Attributstile.
 */
export function Startfehler({ fehler }: { fehler: unknown }) {
  const text = fehler instanceof Error ? fehler.message : String(fehler);

  return (
    <div
      style={{
        fontFamily: "system-ui, sans-serif",
        maxWidth: "40rem",
        margin: "4rem auto",
        padding: "0 1rem",
        lineHeight: 1.6,
      }}
    >
      <h1 style={{ fontSize: "1.25rem" }}>GymBook startet nicht</h1>
      <p>{text}</p>
      <p style={{ color: "#71717a" }}>
        Erwartet wird eine <code>/config.json</code> mit <code>apiUrl</code>,{" "}
        <code>userPoolId</code>, <code>userPoolClientId</code> und <code>region</code>.
        Im Betrieb legt das Deployment sie ab, lokal gehört sie nach{" "}
        <code>public/config.json</code>.
      </p>
    </div>
  );
}
